/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ResourceSharableAssignmentPreference = 'NOT_ALLOWED' | 'PREFERRED' | 'NOT_PREFERRED';

export const ResourceSharableAssignmentPreference = {

    NOT_ALLOWED: 'NOT_ALLOWED' as ResourceSharableAssignmentPreference,

    PREFERRED: 'PREFERRED' as ResourceSharableAssignmentPreference,

    NOT_PREFERRED: 'NOT_PREFERRED' as ResourceSharableAssignmentPreference
};

